import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IonContent, IonRouterOutlet } from '@ionic/angular';
import { Title } from '@angular/platform-browser'
import { LoginInstallChoiceModalComponent } from 'src/app/common/modals/login-install-choice-modal/login-install-choice-modal.component';
import { Page } from 'src/app/core/page';
import { GeneralService } from 'src/app/services/general/general.service';
import { HspQuizService } from 'src/app/services/hsp/hsp-quiz.service';
import { LocaleService } from 'src/app/services/locale/locale-service';
import { LogService } from 'src/app/services/log/log.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { RouterService } from 'src/app/services/router/router.service';
import { UserService } from 'src/app/services/user/user.service';
import { environment } from 'src/environments/environment';

const data = [
  {
    title: '인간이 가장 못하는 게 기술의 발전을<br/>행복으로 전환하는 일이라고 해요',
    descriptionList: [
      'SNS는 내 경험과 취향을 친구들과 공유하고 행복한 관계를 만들기 위한 목적으로 시작되었을 텐데요.',
      '이젠 보여지는 모습에 대해서 과도하게 고민하게 되면서 단편적인 삶의 일부만 서로 나눌 수 있게 된 것 같아요.',
      '행복한 삶에 대해 비슷한 기준으로 바라보게 되고, 내가 원치 않아도 보게되는 수 많은 콘텐츠 속에서 내 관계와 자존감을 온전히 돌보기가 쉽지 않다고 느껴요.'
    ]
  },
  {
    title: '나를 잘 챙기기 위해서, 서로를 잘 알아가기<br/>위해서 우리 다시 <b>‘쓰기’</b> 합시다 ',
    descriptionList: [
      '돌아보면 나를 기록하고 표현하는 가장 좋은 수단은 언제나 텍스트였습니다.',
      '꾸준히 일기를 쓴 사람들은 정신적으로 매우 건강하다고 하는 만큼 무언가를 혼자 쓰는 것만 해도 정말 좋아요.',
      '하지만 저희는 더 재밌게 쓰고 또 친구들과도 나눌 수 있도록 새로운 노트 기능을 개발하게 됐어요.'
    ]
  },
  {
    title: '👻 유쾌한 스티커로 내 노트가<br/>가볍고 재밌어질 수 있도록',
    descriptionList: [
      '글이라는 게 때로 깊고 무겁기도 하고 그래서 오글거리기도 합니다.',
      '그런데 간단하고 재치 있는 스티커 하나로도 충분히 유쾌해 지더라구요. 친구들의 노트에 서로 붙여주기도 하고요.',
      '글로 이해가기가 좀 어렵죠? 아래 구경하기 버튼을 누르면 제 노트를 예시로 볼 수 있어요.',
      '타입스가 서로를 이해하고, 각자의 관계에 도움이 되는 부분이 있기를 바랍니다. 읽어주셔서 감사해요 🙏'
    ]
  },
]
@Component({
  selector: 'app-types-story',
  templateUrl: './types-story.component.html',
  styleUrls: ['./types-story.component.scss'],
})
export class TypesStoryComponent extends Page implements OnInit {


  constructor(
    protected generalService: GeneralService,
    protected routerService: RouterService,
    protected routerOutlet: IonRouterOutlet,
    protected modalService: ModalService,
    protected title: Title,
    protected logService: LogService,
    protected localeService: LocaleService,
    private userService: UserService,
    private elementRef: ElementRef,
  ) {
    super(generalService, routerService, routerOutlet, modalService, title, logService, localeService)
  }
  screenName = 'types_story'
  isLoggedIn = this.userService.isLoggedIn
  contentList = data
  showFloatingButton = true
  ionContent: IonContent | undefined
  webUrl = environment.webUrl



  ngOnInit() {
    this.logService.hspQuiz.logTypesStoryPageViewed()
  }

  onScroll($event): void {
    const scrollY = $event.detail.scrollTop
    const buttonElem = this.elementRef.nativeElement.querySelector('.fixed-app-button')
    if (buttonElem) {
      const elemY = buttonElem.offsetTop;
      this.showFloatingButton = scrollY + window.innerHeight < elemY;
    }
  }

  onClickDeveloperNote() {
    this.logService.hspQuiz.logTypesStoryDevelopersNoteButtonClicked()
    this.routerService.navigate('daily-log/12487')
  }

  async onClickOpenApp(): Promise<void> {
    this.logService.hspQuiz.logTypesStoryAppButtonClicked()
    this.generalService.openInappBrowser('https://types.app.link/iiMmdpauoPb')
  }

  logShareButtonClicked(type: 'kakao' | 'qr' | 'x' | 'link'): void {
    this.logService.hspQuiz.logTypesStoryShareButtonClicked(type)
  }


}
